module.exports = __webpack_public_path__ + "img/taxi.82b67206.svg";